import { Component, OnInit } from "@angular/core";
import { catchError, map, throwError } from "rxjs";
import { BlogService } from "src/app/services/blog.service";
import { environment } from "src/environments/environment";
import { formatDate } from "src/app/utils/date-utils";
import { PageEvent } from "@angular/material/paginator";
import { SeoServiceService } from "src/app/services/seo-service.service";

@Component({
  selector: "app-blog",
  templateUrl: "./blog.component.html",
  styleUrls: ["./blog.component.scss"],
})
export class BlogComponent implements OnInit {
  blogs: any;
  public pageslice: any;

  constructor(
    private blog: BlogService,
    private seoService: SeoServiceService
  ) {}

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.getBlogs();
  }

  getBlogs() {
    this.blog
      .getgenre()
      .pipe(
        map((res: any) => {
          this.blogs = res.data;
          this.blogs.reverse();
          this.pageslice = this.blogs.slice(0, 9);
        }),
        catchError((error) => {
          return throwError(error.massage || error);
        })
      )
      .subscribe();
  }

  getImage(imageURL: String) {
    return environment.baseBlogUrl + imageURL;
  }

  getAuthorImage(imageURL: String) {
    return environment.baseBlogUrl + imageURL;
  }

  Date(date: string) {
    return formatDate(date);
  }

  onPageChange(event: PageEvent) {
    const startindex = event.pageIndex * event.pageSize;
    let endindex = startindex + event.pageSize;
    if (endindex > this.blogs.Length) {
      endindex = this.blogs.Length;
    }
    this.pageslice = this.blogs.slice(startindex, endindex);
  }
}
